module.exports = __webpack_public_path__ + "static/media/aim.375330ce.png";